import { useState } from 'react';
import { Box, Typography, Button, Snackbar } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useAdminUsers } from '../hooks';
import { AdminUserTable, AdminUserCreateDialog, AdminUserEditDialog } from '../components';
import type { AdminUser } from '@/types/domain';

export default function AdminUsers() {
  const { t } = useTranslation();
  const { users, loading, error, success, create, update, delete: deleteUser, refresh, clearMessages } = useAdminUsers();
  const [createOpen, setCreateOpen] = useState(false);
  const [editingUser, setEditingUser] = useState<AdminUser | null>(null);

  return (
    <Box>
      {/* 页面标题和操作按钮 */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4">{t('users.title')}</Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => {
            clearMessages();
            setCreateOpen(true);
          }}
        >
          {t('users.addAdminUser')}
        </Button>
      </Box>

      {/* 用户列表表格 */}
      <AdminUserTable
        users={users}
        loading={loading}
        onEdit={setEditingUser}
        onDelete={deleteUser}
      />

      {/* 创建用户对话框 */}
      <AdminUserCreateDialog
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onSuccess={refresh}
        error={error}
        onCreate={create}
        clearError={clearMessages}
      />

      {/* 编辑用户对话框 */}
      <AdminUserEditDialog
        open={!!editingUser}
        user={editingUser}
        onClose={() => setEditingUser(null)}
        onSuccess={refresh}
        error={error}
        onUpdate={update}
        clearError={clearMessages}
      />

      {/* 成功提示 */}
      <Snackbar
        open={!!success}
        autoHideDuration={3000}
        onClose={clearMessages}
        message={success}
      />
    </Box>
  );
}
